import { IGroup } from 'src/utilities/useSearchHooks';

export function transformGroupsToIds(groups: IGroup[]): string[] {
  return groups.map((group) => group.id);
}

export function transformIdsToPayload(selections: string[]): {
  groupIds: string[];
} {
  return { groupIds: selections };
}
